export default __webpack_public_path__ + "static/media/transportation-dk.aca5311c.svg";